import useMediaQuery from "~/common/hooks/useMediaQuery";
import { Trans, useTranslation } from "react-i18next";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/common/utils/screenSizes";

const RegisterFreeSuccessPage = () => {
  const { i18n } = useTranslation();
  const registrationSuccessImgUrl = "/_ui/responsive/theme-alpha/images/registration-success.png";

  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);
  return (
    <div className={"register-success " + (isDesktop ? "register-desktop" : "register-mobile")}>
      <h1 className="register-success__message">
        <Trans i18n={i18n} i18nKey={"page.registerSuccess.message"} />
      </h1>
      <img className="register-success__image" src={registrationSuccessImgUrl} />
    </div>
  );
};

export function createRegisterFreeSuccessPage() {
  return <RegisterFreeSuccessPage />;
}
